import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class JpgToPdfService {
  // constructor() {}

  public async convertBase64ImageToPdf(base64Image: string, outputFileName = 'documento.pdf'): Promise<File | null> {
    try {
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const img = new Image();
      img.src = base64Image;

      return new Promise<File | null>((resolve, reject) => {
        img.onload = () => {
          const pdfWidth = pdf.internal.pageSize.width;
          const pdfHeight = pdf.internal.pageSize.height;

          const rotateImg = img.width > img.height;

          const imgWidth = rotateImg ? img.height : img.width;
          const imgHeight = rotateImg ? img.width : img.height;

          const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

          const finalWidth = imgWidth * ratio;
          const finalHeight = imgHeight * ratio;

          const posx = (pdfWidth - finalWidth) / 2;
          const posy = (pdfHeight - finalHeight) / 2;

          pdf.addImage(
            base64Image,
            'JPEG',
            posx,
            rotateImg ? posy - finalWidth : posy,
            rotateImg ? finalHeight : finalWidth,
            rotateImg ? finalWidth : finalHeight,
            'Attachment',
            'FAST',
            rotateImg ? -90 : 0,
          );

          const pdfBlob = pdf.output('blob');
          const pdfFile = new File([pdfBlob], outputFileName, {
            type: 'application/pdf',
          });

          resolve(pdfFile);
        };

        img.onerror = (error) => {
          console.error('Error al cargar la imagen', error);
          reject(null);
        };
      });
    } catch (error) {
      console.error(`Error: ${error}`);
      throw error;
      // console.error('Error al convertir la imagen a PDF', error);
      // return null;
    }
  }

  // TODO: Not in use for now, but maybe is necessary when the image comes from file????
  public async convertFileImageToPdf(imageFile: File, outputFileName = 'documento.pdf'): Promise<File | null> {
    try {
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = () => {
          const base64Image = reader.result as string;
          const pdfFile = this.convertBase64ImageToPdf(base64Image, outputFileName);
          if (pdfFile) {
            resolve(pdfFile);
          } else {
            reject(null);
          }
        };

        reader.onerror = (error) => {
          console.error('Error al leer el archivo de imagen', error);
          reject(null);
        };

        reader.readAsDataURL(imageFile);
      });
    } catch (error) {
      console.error('Error al convertir archivo de imagen a PDF', error);
      return null;
    }
  }
}
